import Booking from 'components/booking/Booking';
import CampaignBanner from 'components/campaigns/CampaignBanner';
import { HeadMeta } from 'components/HeadMeta';
import {
  getSharedPageProps as getSharedLayoutProps,
  SharedPageProps,
} from 'components/Layout';
import HeroBlock from 'components/umbraco/HeroBlock';
import { GetAvailableProductsByFacility } from 'helpers/coreApi';
import { BlockRenderer, getStartpage } from 'helpers/umbracoApi';
import { GetStaticProps } from 'next';
import { ProductDto } from 'types/generic';
import { HeroProps, StartPage } from 'types/umbraco';

interface Props extends StartPage {
  productsByFacility: Record<string, ProductDto[]>;
  sharedPageProps: SharedPageProps;
}

export default function Home({
  sharedPageProps,
  productsByFacility,
  blocks,
  meta,
}: Props): JSX.Element {
  const firstBlockIsHeroBlock =
    blocks?.[0]?.content.contentType === 'heroBlock';
  return (
    <>
      <HeadMeta {...meta} />
      {firstBlockIsHeroBlock && (
        <HeroBlock {...(blocks[0].content.properties as HeroProps)}>
          <Booking
            facilities={sharedPageProps.facilities}
            productsByFacility={productsByFacility}
          />
        </HeroBlock>
      )}
      <CampaignBanner
        campaigns={sharedPageProps.campaigns}
        campaignLevel="Top"
      />
      <BlockRenderer items={blocks?.slice(firstBlockIsHeroBlock ? 1 : 0)} />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const startpage = await getStartpage();
  const sharedPageProps = await getSharedLayoutProps();
  const productsByFacility = await GetAvailableProductsByFacility();

  return {
    revalidate: 20,
    props: { ...startpage, productsByFacility, ...sharedPageProps },
  };
};
